export default {
  index: [
    {
      path: '/qytaskbz',
      component: resolve => require(['./qytaskbzIndex.vue'], resolve),
    }
  ]
}



// WEBPACK FOOTER //
// ./src/view/qy_taskbz/_router.js